import {abilityFeature} from '../abilityFeature';

export const hasSelectedInteractions = abilityFeature({
  key: 'hasSelectedInteractions',
  isValid(state, expected) {
    const isAnyInteractionSelected =
      Boolean(state.IX3Store.selectedInteractionId) ||
      Boolean(state.IX2UiStore.selectedInteractionId) ||
      Boolean(state.IX2UiStore.selectedActionListId);

    return isAnyInteractionSelected === expected;
  },
});
